import React, { useState } from 'react';
import classNames from "classnames";
import IconChevronDown from '@/lib/assets/images/chev-down.svg';
import { AnimatePresence, LazyMotion, m } from 'framer-motion';
import { useClickAway } from "@uidotdev/usehooks";

const Dropdown = ({ heading, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Always call useClickAway hook - it will handle SSR internally
  const ref = useClickAway(() => {
    if (typeof window !== 'undefined') {
      setIsOpen(false);
    }
  });

  return (
    <LazyMotion features={() => import("framer-motion").then((mod) => mod.domAnimation)}>
      <div className={classNames(`md:relative md:h-11 z-10`, className)} ref={ref}>
        <div
          className={classNames(
            `md:absolute md:left-0 md:top-0 md:right-0 md:z-10`,
            `bg-white dark:bg-black`,
            `w-full rounded-3xl overflow-hidden`,
            `border-2 border-navy dark:border-silver`
          )}>
          <button
            onClick={toggleDropdown}
            className="w-full px-4 py-[13px] flex justify-between items-center text-navy dark:text-silver"
          >
            <span className="uppercase text-xs font-bold">{heading}</span>
            <m.span
              initial={false}
              animate={{ rotate: isOpen ? 180 : 0 }}
              transition={{ duration: 0.25 }}
            >
              <IconChevronDown />
            </m.span>
          </button>

          <AnimatePresence>
            <m.div
              animate={{ height: (isOpen ? 'auto' : 0) }}
              transition={{ duration: 0.25 }}
              className={`h-0 overflow-hidden`}
            >
              <div className="max-h-[500px] overflow-y-auto mom-scrollbar-hide">
                <div className="px-4 py-2">
                  {children}
                </div>
              </div>
            </m.div>
          </AnimatePresence>
        </div>
      </div>
    </LazyMotion>
  );
};

export default Dropdown;
